module.exports = __webpack_public_path__ + "img/hy_icon2.782375df.png";